var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.value || !_vm.value.url ? _c('div', {
    staticClass: "pa-4"
  }, [_c('v-alert', {
    attrs: {
      "type": "info",
      "outlined": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentDetail.noDocument")) + " ")])], 1) : _vm.value.isSigned ? _c('div', [_vm.value.url ? _c('iframe', {
    staticClass: "pdf",
    staticStyle: {
      "width": "100%"
    },
    style: "height: ".concat(_vm.height),
    attrs: {
      "title": "pdf",
      "src": _vm.value.url
    }
  }) : _vm._e()]) : _vm.value.isTemplate || _vm.value.tokens.length ? _c('div', [_vm.$vuetify.breakpoint.mdAndUp ? _c('sign-document-editor', {
    ref: "signFormEditor",
    attrs: {
      "readonly": true,
      "height": _vm.height
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }) : _vm._e()], 1) : _c('div', [_vm.value.url ? _c('iframe', {
    staticClass: "pdf",
    staticStyle: {
      "width": "100%"
    },
    style: "height: ".concat(_vm.height),
    attrs: {
      "title": "pdf",
      "src": _vm.value.url
    }
  }) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }